import { VideoMedia } from 'theme';

// Managed gallery videos use Prestige's public player API. A source is mounted
// only when its cell is selected and visible; leaving the screen pauses it.
class DfGalleryVideo extends VideoMedia {
  connectedCallback() {
    super.connectedCallback();
    this.dfAbortController = new AbortController();
    this.dfVisibilityObserver = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting) this.pause();
      else if (this.hasAttribute('autoplay')) this.play();
    });
    this.dfVisibilityObserver.observe(this);
    this.addEventListener('play', () => {
      if (!this.isGalleryCellVisible()) this.querySelector('video')?.pause();
    }, { capture: true, signal: this.dfAbortController.signal });
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) this.pause();
      else if (this.hasAttribute('autoplay')) this.play();
    }, { signal: this.dfAbortController.signal });
  }

  disconnectedCallback() {
    this.querySelector('video')?.pause();
    this.dfVisibilityObserver?.disconnect();
    this.dfAbortController?.abort();
    super.disconnectedCallback();
  }

  isGalleryCellVisible() {
    const bounds = this.getBoundingClientRect();
    if (document.hidden || !bounds.width || !bounds.height || bounds.bottom <= 0 || bounds.top >= innerHeight || bounds.right <= 0 || bounds.left >= innerWidth) return false;
    const gallery = this.closest('product-gallery');
    return !gallery?.carousel.isScrollable || gallery.carousel.selectedCell === this.closest('.product-gallery__media');
  }

  play() {
    if (!this.isGalleryCellVisible()) return;
    const template = this.querySelector('template[data-df-gallery-video]');
    if (template) {
      template.replaceWith(template.content);
      // Safari needs source selection restarted after mounting inert media.
      this.querySelector('video')?.load();
    }
    super.play();
  }
}

if (!customElements.get('df-gallery-video')) customElements.define('df-gallery-video', DfGalleryVideo);
